import {
  MagnoliaALBISCategory,
  MagnoliaAlbisBrandProps,
} from "components/magnolia/Markets/ALBIS/MagnoliaInteractiveBuildingALBIS";
import {
  MagnoliaMocomCategory,
  MagnoliaStudy,
} from "components/mocom/magnolia/MagnoliaInteractiveAutomotiveMocom";
import { Magnolia } from "domain/Magnolia";
import { convertMultifieldStructure, getHref } from "domain/util/Magnolia";

export const getCategories = (props: {
  metadata: Magnolia.ComponentMetaData;
}) => {
  return convertMultifieldStructure<MagnoliaMocomCategory>(
    "categories",
    props,
    props.metadata["@nodes"]
  ).map((category) => ({
    title: category.title,
    description: category.description,
    id: category.id,
  }));
};

export const getAlbisCategories = (props: {
  metadata: Magnolia.ComponentMetaData;
}) => {
  return convertMultifieldStructure<MagnoliaALBISCategory>(
    "categories",
    props,
    props.metadata["@nodes"]
  ).map((category) => ({
    title: category.title,
    text: category.text,
    id: category.id,
    brands: convertMultifieldStructure<MagnoliaAlbisBrandProps>(
      "brands",
      category,
      // @ts-ignore
      category["@nodes"]
    ).map((brand) => ({
      image: {
        source: brand.image.renditions.cover690x490.link,
        alt: brand.image["@name"],
      },
      link: brand.link ? getHref(brand.link) : undefined,
      products: convertMultifieldStructure<{ label: string }>(
        "products",
        brand,
        // @ts-ignore
        brand["@nodes"]
      ).map((product) => product.label),
    })),
  }));
};

export const getFilterOptions = (categories: MagnoliaMocomCategory[]) => {
  return categories.map((category) => {
    return { title: category.title, id: category.id };
  });
};

export const getStudies = (props: { metadata: Magnolia.ComponentMetaData }) => {
  return convertMultifieldStructure<MagnoliaStudy>(
    "teaser",
    props,
    props.metadata["@nodes"]
  );
};

export const getCaseStudies = (props: {
  metadata: Magnolia.ComponentMetaData;
}) => {
  const studies = getStudies(props);

  return studies.map((study) => {
    return {
      image: {
        source: study.image.renditions.cover690x490.link,
        alt: study.image["@name"],
      },
      imageFullWidth: study.coverImage ?? false,
      link: getHref(study.link),
      description: study.description,
      shortTitle: study.shortTitle,
      title: study.title,
      tag: convertMultifieldStructure<{ id: string }>(
        "tag",
        study,
        study["@nodes"]
      ).map((tag) => tag.id),
    };
  });
};
